<template>
  <div class="zwx-kv">
    <div class="zwx-kv-name">{{ name }}：</div>
    <div class="zwx-kv-value">{{ value }}</div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ZwxKv',
  props: {
    name: {
      type: String,
      required: true,
    },
    value: { type: String },
  },
  data() {
    return {}
  },
  created() { },
  mounted() { },
  computed: {},
  methods: {},
}
</script>

<style lang="less" scoped>
.zwx-kv {
  display: flex;
}

.zwx-kv + .zwx-kv {
  margin-top: 12px;
}

.zwx-kv .zwx-kv-name {
  display: flex;
  justify-content: center;
  white-space: nowrap;
  font-size: 14px;
  line-height: 20px;
  color: #1f2d3d;
  font-weight: 400;
  font-family: PingFangSC, PingFangSC-Regular;
}

.zwx-kv .zwx-kv-value {
  font-size: 14px;
  line-height: 20px;
  color: #1f2d3d;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
}
</style>

<style lang="less"></style>
